import { useEffect, useState,forwardRef,useImperativeHandle } from "react";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";


const SelectListBrand = forwardRef(({
  defaultSelectedItem,
  data,
  onSelect,
  onCloseOtherList
}: {
  defaultSelectedItem: any;
  data: any;
  onSelect: Function;
  onCloseOtherList:Function
},ref) => {
  const [showOptionList, setShowOptionList] = useState(false);
  const [selectedItem, setSelectedItem] = useState(defaultSelectedItem);

  const handleListDisplay = () =>{
    setShowOptionList((showOptionList) => !showOptionList)
  };

  useImperativeHandle(ref, () => ({

    handleCloseListDisplay(){
      setShowOptionList(false)
    }
  }));

  const handleOnSelect = (item:any) => {
    setShowOptionList(false);
    setSelectedItem(item);
    onSelect(item);
  };

  useEffect(()=>{
    if(showOptionList){
      onCloseOtherList()
    }

  },[showOptionList])


  return (
    <div className="w-56 relative ml-3">
      <div
        className={`flex flex-row bg-neutral-600 w-full pl-6 pr-4 py-4 h-16 ${
          showOptionList ? "rounded-t-lg" : "rounded-lg"
        } items-center`}
        onClick={handleListDisplay}
      >
        <span className="flex flex-1 text-gray-300">
          {selectedItem?.brandName ?? "Select Brand"}
        </span>
        {showOptionList ? (
          <AiFillCaretUp fill="#d4d4d8" size={18} />
        ) : (
          <AiFillCaretDown fill="#d4d4d8" size={18} />
        )}
      </div>
      {showOptionList && (
        <ul className="absolute cursor-pointer bg-neutral-600 divide-y rounded-b-lg border-t overflow-y-auto w-56 h-96" >
          {data?.map((item:any) => {
            return (
              <li
                className={`${
                  selectedItem?.key === item.brandId
                    ? "text-gray-300"
                    : "text-gray-300 font-medium"
                } pl-6 p-4`}
                data-name={item.brandName}
                key={item.brandId}
                onClick={() => handleOnSelect(item)}
              >
                {item.brandName}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
);

export default SelectListBrand;